module.exports = __webpack_public_path__ + "static/media/290307.585792bc.png";